/* Customizer v6 — Fabric.js canvas + Cloudinary uploads. Config comes from sections/main-customizer.liquid (#cz-config). */
(function () {
  function boot() {
    if (!window.fabric) { return setTimeout(boot, 60); }
    var cfgEl = document.getElementById('cz-config');
    if (!cfgEl) return;
    var CFG = JSON.parse(cfgEl.textContent);
    var MOCKUPS = JSON.parse(document.getElementById('cz-mockups').textContent);
    var T = CFG.strings;
    var DATA = { products: CFG.products, fees: CFG.fees };

    var PRODUCT_TYPES = [
      { key: 'tshirt', locations: ['front', 'back', 'left_sleeve', 'right_sleeve'] },
      { key: 'hoodie', locations: ['front', 'back'] },
      { key: 'sweater', locations: ['front', 'back'] },
      { key: 'bodysuit', locations: ['front', 'back'] },
      { key: 'bag', locations: ['front', 'back'] }
    ];
    PRODUCT_TYPES.forEach(function (p) { p.label = T.types[p.key]; });

    function parseMap(text) {
      var o = {};
      String(text || '').split(/\r?\n/).forEach(function (line) {
        var i = line.indexOf(':');
        if (i > 0) o[line.slice(0, i).trim().toLowerCase()] = line.slice(i + 1).trim();
      });
      return o;
    }
    var SLUGS = parseMap(CFG.colorSlugs);
    var HEX = parseMap(CFG.swatches);
    function slugify(name) {
      return (name || '').toString().trim().toLowerCase().replace(/[^a-z0-9ა-ჰ]+/g, '-').replace(/^-+|-+$/g, '') || 'na';
    }
    function colorMeta(name) {
      var k = (name || '').trim().toLowerCase();
      return { hex: HEX[k] || '#cccccc', slug: SLUGS[k] || slugify(name) };
    }

    var FONTS = [
      { key: 'sans', label: T.fonts.sans, family: '"Noto Sans Georgian", "Inter", sans-serif', weight: '400' },
      { key: 'serif', label: T.fonts.serif, family: '"Noto Serif Georgian", serif', weight: '400' },
      { key: 'bold', label: T.fonts.bold, family: '"Noto Sans Georgian", "Inter", sans-serif', weight: '700' }
    ];
    if (CFG.customFont) FONTS.push({ key: 'custom', label: T.fonts.custom, family: '"CZ Custom", serif', weight: '400' });
    var TEXT_COLORS = ['#000000', '#ffffff', '#e02020', '#f5d800', '#eafe00', '#1f8a3b', '#29a3e0', '#1a3fa0'];

    function ptByKey(key) { return PRODUCT_TYPES.filter(function (p) { return p.key === key; })[0]; }
    function currentPT() { return ptByKey(state.productType); }
    function isReady(pt) { return DATA.products[pt.key] && DATA.products[pt.key].ready; }

    var state = { productType: 'tshirt', color: null, size: null, quantity: 1, activeLocation: 'front', locationsStore: {} };
    function locStoreKey(t, l) { return t + ':' + l; }
    function ensureLocState(t, l) { var k = locStoreKey(t, l); if (!state.locationsStore[k]) state.locationsStore[k] = { history: [null], historyIndex: 0 }; return state.locationsStore[k]; }
    function currentLocState() { return ensureLocState(state.productType, state.activeLocation); }

    function money(cents) {
      if (window.ThemeMoney) return window.ThemeMoney(cents);
      return (cents / 100).toFixed(2) + ' GEL';
    }
    function norm(s) { return (s || '').toString().trim().toLowerCase(); }
    function findOptionIndex(meta, kind) {
      if (!meta) return -1;
      for (var i = 0; i < meta.length; i++) {
        var n = norm(meta[i] && meta[i].name);
        if (kind === 'color' && (n.indexOf('ფერ') !== -1 || n.indexOf('color') !== -1 || n.indexOf('colour') !== -1)) return i;
        if (kind === 'size' && (n.indexOf('ზომ') !== -1 || n.indexOf('size') !== -1)) return i;
      }
      return -1;
    }
    function colorIndexFor(pt) { var pd = DATA.products[pt.key]; return pd ? findOptionIndex(pd.optionsMeta, 'color') : -1; }
    function sizeIndexFor(pt) { var pd = DATA.products[pt.key]; return pd ? findOptionIndex(pd.optionsMeta, 'size') : -1; }
    function liveColorsFor(pt) {
      var pd = DATA.products[pt.key], idx = colorIndexFor(pt);
      if (!pd || idx === -1) return [];
      return (pd.optionsMeta[idx].values || []).map(function (name) { var m = colorMeta(name); return { name: name, hex: m.hex, slug: m.slug }; });
    }
    function liveSizesFor(pt) {
      var pd = DATA.products[pt.key], idx = sizeIndexFor(pt);
      if (!pd || idx === -1) return [];
      return pd.optionsMeta[idx].values || [];
    }
    function findVariant() {
      var pt = currentPT(), pd = DATA.products[pt.key];
      if (!pd) return null;
      var ci = colorIndexFor(pt), si = sizeIndexFor(pt), sizes = liveSizesFor(pt);
      return pd.variants.filter(function (v) {
        if (ci === -1 || norm(v.options[ci]) !== norm(state.color)) return false;
        if (sizes.length === 0) return true;
        if (si === -1) return false;
        return norm(v.options[si]) === norm(state.size);
      })[0] || null;
    }
    function sizeAvailable(size) {
      var pt = currentPT(), pd = DATA.products[pt.key], ci = colorIndexFor(pt), si = sizeIndexFor(pt);
      return pd.variants.some(function (v) { return norm(v.options[ci]) === norm(state.color) && norm(v.options[si]) === norm(size) && v.available; });
    }

    /* ---------- Fabric canvas ---------- */
    var stageEl = document.getElementById('cz_canvas_stage');
    var fabricCanvas = new fabric.Canvas('cz_fabric_canvas', { selection: true, preserveObjectStacking: true });
    var isRestoring = false;

    /* ---------- max photo size (A4 / A5) ---------- */
    var PRINT_MAX = CFG.printMax || {};
    function maxBox() {
      var m = PRINT_MAX[state.productType] || { pct: 39, label: 'A4', cm: '21×29.7' };
      var L = fabricCanvas.getWidth() * (Number(m.pct) || 39) / 100;
      return { long: L, short: L / Math.SQRT2, label: m.label, cm: m.cm };
    }
    function isPhoto(o) { return o && o.type === 'image'; }
    function clampPhoto(o) {
      if (!isPhoto(o)) return false;
      var b = maxBox(), w = o.getScaledWidth(), h = o.getScaledHeight();
      var k = Math.min(1, b.long / Math.max(w, h), b.short / Math.min(w, h));
      if (k < 0.9999) { o.scaleX *= k; o.scaleY *= k; o.setCoords(); return true; }
      return false;
    }
    var hintTimer;
    function showMaxHint() {
      var b = maxBox(), el = document.getElementById('cz_uploading_msg');
      if (!el) return;
      el.textContent = (T.maxSize || 'ფოტოს მაქსიმალური ზომა') + ' — ' + b.label + ' (' + b.cm + ' სმ)';
      clearTimeout(hintTimer); hintTimer = setTimeout(function () { el.textContent = ''; }, 2500);
    }
    /* dashed frame around the selected photo = biggest size it can have */
    fabricCanvas.on('after:render', function (opt) {
      var o = fabricCanvas.getActiveObject();
      if (!isPhoto(o) || !opt || !opt.ctx) return;
      var b = maxBox(), portrait = o.getScaledHeight() >= o.getScaledWidth();
      var fw = portrait ? b.short : b.long, fh = portrait ? b.long : b.short;
      var c = o.getCenterPoint(), x = c.x - fw / 2, y = c.y - fh / 2;
      var W = fabricCanvas.getWidth(), H = fabricCanvas.getHeight();
      x = Math.max(0, Math.min(W - fw, x)); y = Math.max(0, Math.min(H - fh, y));
      var ctx = opt.ctx; ctx.save();
      ctx.setLineDash([6, 5]); ctx.lineWidth = 1.5; ctx.strokeStyle = 'rgba(234,254,0,.95)';
      ctx.strokeRect(x + .5, y + .5, fw - 1, fh - 1);
      ctx.setLineDash([]); ctx.font = '600 11px "Noto Sans Georgian", sans-serif';
      var label = 'მაქს. ' + b.label, tw = ctx.measureText(label).width + 10;
      ctx.fillStyle = '#111'; ctx.fillRect(x, y, tw, 18); ctx.fillStyle = '#EAFE00'; ctx.fillText(label, x + 5, y + 13);
      ctx.restore();
    });
    function sizeCanvasToStage() {
      var size = stageEl.clientWidth;
      if (!size) return;
      var old = fabricCanvas.getWidth();
      fabricCanvas.setWidth(size); fabricCanvas.setHeight(size);
      if (old && old !== size) {
        var k = size / old;
        fabricCanvas.getObjects().forEach(function (o) { o.scaleX *= k; o.scaleY *= k; o.left *= k; o.top *= k; o.setCoords(); });
      }
      fabricCanvas.calcOffset(); updateBackground(); fabricCanvas.requestRenderAll();
    }
    function pushHistory() {
      if (isRestoring) return;
      var loc = currentLocState();
      var json = JSON.stringify(fabricCanvas.toJSON(['selectable', '__fontKey']));
      loc.history = loc.history.slice(0, loc.historyIndex + 1);
      loc.history.push(json);
      loc.historyIndex = loc.history.length - 1;
      refreshToolButtons(); renderLocationBadges(); renderPrice();
    }
    function loadLocationCanvas(cb) {
      isRestoring = true;
      var json = currentLocState().history[currentLocState().historyIndex];
      fabricCanvas.clear();
      if (json) {
        fabricCanvas.loadFromJSON(json, function () { fabricCanvas.getObjects().forEach(clampPhoto); fabricCanvas.renderAll(); isRestoring = false; if (cb) cb(); });
      } else { fabricCanvas.renderAll(); isRestoring = false; if (cb) cb(); }
    }
    function refreshToolButtons() {
      var loc = currentLocState();
      document.getElementById('cz_undo_btn').disabled = loc.historyIndex <= 0;
      document.getElementById('cz_redo_btn').disabled = loc.historyIndex >= loc.history.length - 1;
    }
    function locHasContent(t, l) {
      var loc = ensureLocState(t, l), json = loc.history[loc.historyIndex];
      if (!json) return false;
      try { var p = JSON.parse(json); return p.objects && p.objects.length > 0; } catch (e) { return false; }
    }
    fabricCanvas.on('object:modified', pushHistory);
    fabricCanvas.on('object:added', function () { if (!isRestoring) pushHistory(); });
    fabricCanvas.on('object:removed', function () { if (!isRestoring) pushHistory(); });
    fabricCanvas.on('object:moving', function (e) {
      var obj = e.target, b = obj.getBoundingRect(), w = fabricCanvas.getWidth(), h = fabricCanvas.getHeight();
      if (b.left < 0) obj.left -= b.left;
      if (b.top < 0) obj.top -= b.top;
      if (b.left + b.width > w) obj.left -= (b.left + b.width - w);
      if (b.top + b.height > h) obj.top -= (b.top + b.height - h);
    });
    fabricCanvas.on('object:scaling', function (e) {
      if (clampPhoto(e.target)) showMaxHint();
    });
    fabricCanvas.on('selection:created', onSelectionChange);
    fabricCanvas.on('selection:updated', onSelectionChange);
    fabricCanvas.on('selection:cleared', onSelectionChange);
    function onSelectionChange() {
      var obj = fabricCanvas.getActiveObject();
      var removeBtn = document.getElementById('cz_remove_obj_btn'), styleRow = document.getElementById('cz_text_style_row');
      removeBtn.hidden = !obj;
      styleRow.hidden = !(obj && obj.type === 'textbox');
      if (obj && obj.type === 'textbox') {
        document.getElementById('cz_font_select').value = obj.__fontKey || 'sans';
        Array.prototype.forEach.call(document.getElementById('cz_text_colors').children, function (sw) { sw.classList.toggle('is-active', sw.dataset.color === obj.fill); });
      }
    }
    document.getElementById('cz_remove_obj_btn').addEventListener('click', function () {
      var obj = fabricCanvas.getActiveObject();
      if (obj) { fabricCanvas.remove(obj); fabricCanvas.discardActiveObject(); fabricCanvas.requestRenderAll(); }
    });
    function afterLoad() { updateBackground(); refreshToolButtons(); renderLocationBadges(); renderPrice(); onSelectionChange(); }
    document.getElementById('cz_undo_btn').addEventListener('click', function () {
      var loc = currentLocState(); if (loc.historyIndex <= 0) return; loc.historyIndex--; loadLocationCanvas(afterLoad);
    });
    document.getElementById('cz_redo_btn').addEventListener('click', function () {
      var loc = currentLocState(); if (loc.historyIndex >= loc.history.length - 1) return; loc.historyIndex++; loadLocationCanvas(afterLoad);
    });
    document.getElementById('cz_clear_btn').addEventListener('click', function () {
      var loc = currentLocState(); loc.history = [null]; loc.historyIndex = 0; loadLocationCanvas(afterLoad);
    });

    /* ---------- text / photo ---------- */
    document.getElementById('cz_add_text_btn').addEventListener('click', function () {
      var f = FONTS[0], w = fabricCanvas.getWidth();
      var hex = colorMeta(state.color).hex.replace('#', '');
      var lum = hex.length === 6 ? (parseInt(hex.substr(0, 2), 16) * 299 + parseInt(hex.substr(2, 2), 16) * 587 + parseInt(hex.substr(4, 2), 16) * 114) / 1000 : 255;
      var tb = new fabric.Textbox(T.yourText, { left: w * 0.3, top: w * 0.3, width: w * 0.4, fontSize: Math.round(w / 15), fontFamily: f.family, fontWeight: f.weight, fill: lum < 128 ? '#ffffff' : '#000000', textAlign: 'center' });
      tb.__fontKey = f.key;
      fabricCanvas.add(tb); fabricCanvas.setActiveObject(tb); tb.enterEditing(); tb.selectAll(); fabricCanvas.requestRenderAll();
    });
    document.getElementById('cz_upload_input').addEventListener('change', function (e) {
      var file = e.target.files[0];
      if (!file) return;
      var msg = document.getElementById('cz_uploading_msg');
      msg.textContent = T.uploading;
      uploadToCloudinary(file).then(function (url) {
        msg.textContent = '';
        fabric.Image.fromURL(url, function (img) {
          var w = fabricCanvas.getWidth();
          img.scaleToWidth(w * 0.36); clampPhoto(img);
          img.set({ left: (w - img.getScaledWidth()) / 2, top: Math.max(0, w * 0.46 - img.getScaledHeight() / 2) });
          img.setCoords();
          fabricCanvas.add(img); fabricCanvas.setActiveObject(img); fabricCanvas.requestRenderAll();
        }, { crossOrigin: 'anonymous' });
      }).catch(function (err) { console.error(err); msg.textContent = ''; alert(T.uploadFailed); });
      e.target.value = '';
    });
    function uploadToCloudinary(fileOrDataUrl) {
      var fd = new FormData();
      fd.append('file', fileOrDataUrl);
      fd.append('upload_preset', CFG.uploadPreset);
      return fetch('https://api.cloudinary.com/v1_1/' + CFG.cloudName + '/image/upload', { method: 'POST', body: fd })
        .then(function (r) { return r.json(); })
        .then(function (d) { if (!d.secure_url) throw new Error('no secure_url'); return d.secure_url; });
    }
    var fontSelect = document.getElementById('cz_font_select');
    FONTS.forEach(function (f) { var o = document.createElement('option'); o.value = f.key; o.textContent = f.label; fontSelect.appendChild(o); });
    fontSelect.addEventListener('change', function () {
      var obj = fabricCanvas.getActiveObject();
      if (!obj || obj.type !== 'textbox') return;
      var f = FONTS.filter(function (x) { return x.key === fontSelect.value; })[0];
      obj.set({ fontFamily: f.family, fontWeight: f.weight }); obj.__fontKey = f.key;
      fabricCanvas.requestRenderAll(); pushHistory();
    });
    var textColorsEl = document.getElementById('cz_text_colors');
    TEXT_COLORS.forEach(function (c) {
      var sw = document.createElement('button');
      sw.type = 'button'; sw.className = 'cz__text-color'; sw.style.background = c; sw.dataset.color = c; sw.setAttribute('aria-label', c);
      sw.addEventListener('click', function () {
        var obj = fabricCanvas.getActiveObject();
        if (!obj || obj.type !== 'textbox') return;
        obj.set({ fill: c }); fabricCanvas.requestRenderAll();
        Array.prototype.forEach.call(textColorsEl.children, function (x) { x.classList.remove('is-active'); });
        sw.classList.add('is-active'); pushHistory();
      });
      textColorsEl.appendChild(sw);
    });

    /* ---------- product type / colour / size / location ---------- */
    var ptEl = document.getElementById('cz_product_types');
    function renderProductTypes() {
      ptEl.innerHTML = '';
      PRODUCT_TYPES.forEach(function (p) {
        var ready = isReady(p);
        var el = document.createElement('button');
        el.type = 'button';
        el.className = 'cz__type' + (p.key === state.productType ? ' is-active' : '');
        el.disabled = !ready;
        el.innerHTML = '<span class="cz__type-icon" data-icon="' + p.key + '"></span><span>' + p.label + (ready ? '' : ' <small>' + T.soon + '</small>') + '</span>';
        el.addEventListener('click', function () {
          if (!ready || p.key === state.productType) return;
          state.productType = p.key;
          var lc = liveColorsFor(p), ls = liveSizesFor(p);
          state.color = lc[0] ? lc[0].name : null;
          state.size = ls[0] || null;
          state.activeLocation = p.locations[0];
          renderProductTypes(); renderColors(); renderSizes(); renderLocations();
          loadLocationCanvas(afterLoad);
        });
        ptEl.appendChild(el);
      });
    }
    var colorsEl = document.getElementById('cz_colors'), colorNameEl = document.getElementById('cz_color_name');
    function renderColors() {
      colorsEl.innerHTML = '';
      colorNameEl.textContent = state.color || '';
      liveColorsFor(currentPT()).forEach(function (c) {
        var el = document.createElement('button');
        el.type = 'button';
        el.className = 'color-swatch' + (c.name === state.color ? ' is-selected' : '');
        el.title = c.name; el.setAttribute('aria-label', c.name);
        el.innerHTML = '<span class="color-swatch__dot" style="--sw:' + c.hex + ';"></span>';
        el.addEventListener('click', function () {
          state.color = c.name; colorNameEl.textContent = c.name;
          Array.prototype.forEach.call(colorsEl.children, function (ch) { ch.classList.remove('is-selected'); });
          el.classList.add('is-selected');
          renderSizes(); updateBackground(); renderPrice();
        });
        colorsEl.appendChild(el);
      });
    }
    var sizesEl = document.getElementById('cz_sizes'), sizeSectionEl = document.getElementById('cz_size_section');
    function renderSizes() {
      sizesEl.innerHTML = '';
      var sizes = liveSizesFor(currentPT());
      sizeSectionEl.hidden = sizes.length === 0;
      sizes.forEach(function (s) {
        var el = document.createElement('button');
        el.type = 'button';
        el.className = 'pdp__pill' + (s === state.size ? ' is-selected' : '') + (state.color && !sizeAvailable(s) ? ' is-unavailable' : '');
        el.textContent = s;
        el.addEventListener('click', function () {
          state.size = s;
          Array.prototype.forEach.call(sizesEl.children, function (ch) { ch.classList.remove('is-selected'); });
          el.classList.add('is-selected'); renderPrice();
        });
        sizesEl.appendChild(el);
      });
    }
    var locEl = document.getElementById('cz_locations');
    function renderLocations() {
      locEl.innerHTML = '';
      currentPT().locations.forEach(function (locKey) {
        var el = document.createElement('button');
        el.type = 'button';
        el.setAttribute('role', 'tab');
        el.className = 'cz__loc' + (locKey === state.activeLocation ? ' is-active' : '');
        el.textContent = T.locations[locKey];
        el.addEventListener('click', function () {
          if (locKey === state.activeLocation) return;
          state.activeLocation = locKey;
          Array.prototype.forEach.call(locEl.children, function (ch) { ch.classList.remove('is-active'); });
          el.classList.add('is-active');
          document.getElementById('cz_stage_label').textContent = T.locations[locKey];
          loadLocationCanvas(afterLoad);
        });
        locEl.appendChild(el);
      });
      document.getElementById('cz_stage_label').textContent = T.locations[state.activeLocation] || '';
      renderLocationBadges();
    }
    function renderLocationBadges() {
      var pt = currentPT();
      Array.prototype.forEach.call(locEl.children, function (btn, idx) {
        btn.classList.toggle('has-design', locHasContent(pt.key, pt.locations[idx]));
      });
    }
    function updateBackground() {
      var pt = currentPT();
      if (!state.color) { fabricCanvas.setBackgroundImage(null, fabricCanvas.requestRenderAll.bind(fabricCanvas)); return; }
      var url = MOCKUPS[pt.key + '_' + state.activeLocation + '_' + colorMeta(state.color).slug];
      if (!url) { fabricCanvas.setBackgroundImage(null, fabricCanvas.requestRenderAll.bind(fabricCanvas)); return; }
      fabric.Image.fromURL(url, function (img) {
        var cw = fabricCanvas.getWidth(), ch = fabricCanvas.getHeight();
        var scale = Math.max(cw / img.width, ch / img.height);
        img.set({ originX: 'center', originY: 'center', left: cw / 2, top: ch / 2, scaleX: scale, scaleY: scale, selectable: false, evented: false });
        fabricCanvas.setBackgroundImage(img, fabricCanvas.requestRenderAll.bind(fabricCanvas));
      }, { crossOrigin: 'anonymous' });
    }

    /* ---------- price ---------- */
    function calc() {
      var pt = currentPT(), variant = findVariant(), lines = [], total = 0;
      if (variant) {
        total += variant.price;
        lines.push({ label: pt.label + (liveSizesFor(pt).length && state.size ? ', ' + state.size : '') + (state.color ? ', ' + state.color : ''), amount: variant.price });
      }
      pt.locations.filter(function (l) { return locHasContent(pt.key, l); }).forEach(function (l) {
        total += DATA.fees.perLocation.price;
        lines.push({ label: T.locations[l] + ' — ' + T.printLine, amount: DATA.fees.perLocation.price });
      });
      return { lines: lines, grandTotal: total * state.quantity };
    }
    function renderPrice() {
      var r = calc(), linesEl = document.getElementById('cz_price_lines');
      linesEl.innerHTML = '';
      r.lines.forEach(function (l) {
        var d = document.createElement('div'); d.className = 'cz__line';
        d.innerHTML = '<span></span><span>' + money(l.amount) + '</span>';
        d.firstChild.textContent = l.label;
        linesEl.appendChild(d);
      });
      if (state.quantity > 1) {
        var q = document.createElement('div'); q.className = 'cz__line';
        q.innerHTML = '<span>' + T.qtyLine + ' × ' + state.quantity + '</span><span></span>';
        linesEl.appendChild(q);
      }
      document.getElementById('cz_price_total').textContent = money(r.grandTotal);
    }

    /* ---------- quantity ---------- */
    var qtyInput = document.getElementById('cz_qty_input');
    document.getElementById('cz_qty_minus').addEventListener('click', function () { state.quantity = Math.max(1, state.quantity - 1); qtyInput.value = state.quantity; renderPrice(); });
    document.getElementById('cz_qty_plus').addEventListener('click', function () { state.quantity += 1; qtyInput.value = state.quantity; renderPrice(); });
    qtyInput.addEventListener('change', function () { var v = parseInt(qtyInput.value, 10); state.quantity = (isNaN(v) || v < 1) ? 1 : v; qtyInput.value = state.quantity; renderPrice(); });

    /* ---------- add to cart ---------- */
    var msgEl = document.getElementById('cz_msg');
    function loadLocationCanvasP() { return new Promise(function (resolve) { loadLocationCanvas(resolve); }); }
    function generateLocationImages() {
      var pt = currentPT(), saved = state.activeLocation, todo = pt.locations.filter(function (l) { return locHasContent(pt.key, l); }), results = {};
      function next(i) {
        if (i >= todo.length) { state.activeLocation = saved; return loadLocationCanvasP().then(function () { updateBackground(); return results; }); }
        state.activeLocation = todo[i];
        return loadLocationCanvasP().then(function () {
          return new Promise(function (res) { updateBackground(); setTimeout(res, 350); });
        }).then(function () {
          /* 1) print file: design only, transparent, ~2000 px  2) preview: design on the mockup */
          var bg = fabricCanvas.backgroundImage;
          fabricCanvas.discardActiveObject();
          fabricCanvas.backgroundImage = null; fabricCanvas.renderAll();
          var printUrl = fabricCanvas.toDataURL({ format: 'png', multiplier: Math.max(1, 2000 / fabricCanvas.getWidth()) });
          fabricCanvas.backgroundImage = bg; fabricCanvas.renderAll();
          var previewUrl = fabricCanvas.toDataURL({ format: 'jpeg', quality: 0.86, multiplier: Math.max(1, 900 / fabricCanvas.getWidth()) });
          return Promise.all([uploadToCloudinary(printUrl), uploadToCloudinary(previewUrl)]).then(function (urls) {
            results[todo[i]] = { file: urls[0], preview: urls[1] };
            return next(i + 1);
          });
        });
      }
      return next(0);
    }
    function err(text) { msgEl.className = 'cz__msg is-error'; msgEl.textContent = text; }
    var addBtn = document.getElementById('cz_add_btn'), addBtnText = addBtn.querySelector('span');
    addBtn.addEventListener('click', function () {
      msgEl.className = 'cz__msg'; msgEl.textContent = '';
      var pt = currentPT();
      if (!state.color || (liveSizesFor(pt).length && !state.size)) return err(T.chooseColorSize);
      var variant = findVariant();
      if (!variant || !variant.available) return err(T.unavailable);
      var selected = pt.locations.filter(function (l) { return locHasContent(pt.key, l); });
      if (selected.length === 0) return err(T.addDesign);
      addBtn.disabled = true; addBtnText.textContent = T.working;
      generateLocationImages().then(function (images) {
        var props = {};
        props[T.propProduct] = pt.label;
        props[T.propColor] = state.color;
        if (liveSizesFor(pt).length) props[T.propSize] = state.size;
        selected.forEach(function (l) {
          props[T.locations[l] + ' - ' + T.propFile] = images[l].file;
          props[T.locations[l] + ' - ' + T.propPreview] = images[l].preview;
        });
        var items = [{ id: variant.id, quantity: state.quantity, properties: props }];
        if (DATA.fees.perLocation.variantId) items.push({ id: DATA.fees.perLocation.variantId, quantity: selected.length * state.quantity });
        return fetch(CFG.cartAddUrl, { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: items }) });
      }).then(function (r) {
        if (!r.ok) throw new Error('cart add failed');
        return r.json();
      }).then(function () { window.location.href = CFG.cartUrl; })
        .catch(function (e) { console.error(e); addBtn.disabled = false; addBtnText.textContent = T.addToCart; err(T.failed); });
    });

    /* ---------- init ---------- */
    window.addEventListener('resize', function () { clearTimeout(window.__czR); window.__czR = setTimeout(sizeCanvasToStage, 120); });
    var firstPT = PRODUCT_TYPES.filter(isReady)[0] || PRODUCT_TYPES[0];
    state.productType = firstPT.key;
    var fc = liveColorsFor(firstPT), fs = liveSizesFor(firstPT);
    state.color = fc[0] ? fc[0].name : null;
    state.size = fs[0] || null;
    state.activeLocation = firstPT.locations[0];
    renderProductTypes(); renderColors(); renderSizes(); renderLocations();
    sizeCanvasToStage(); setTimeout(sizeCanvasToStage, 300);
    refreshToolButtons(); renderPrice();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();